export default __webpack_public_path__ + "static/pic6-0e14136d1704d6dca2cc11ea5c4eb9e0.jpg";